import { ProjectDetailsSection } from "../../../../shared/screen-components/DeliverableDetailsComponent/DeliverableDetailsComponent";

export const DeliverableDetails = () => {
  return <ProjectDetailsSection />;
};
